export default __webpack_public_path__ + "static/shehzad-ahmed-b0b7b27c521469db6af7c7c4878c49f9.png";